import { makeStyles } from "@mui/styles";
import { BaseThemeOptions } from "themes/base";

export const useStyles = makeStyles((theme: BaseThemeOptions) => ({
	sbIconDateBox: {
		height: "100%",
		border: "1px solid #E2DDF2",
		backgroundColor: "white",
		borderRadius: 0,
		borderTopLeftRadius: 4,
		borderBottomLeftRadius: 4,
	},
	sbDateBox: {
		border: "1px solid #E2DDF2",
		borderLeft: "none",
		backgroundColor: "white",
		minWidth: 98,
		padding: "6px 10px",
	},
	sbConfigMenuIconDateBox: {
		height: 37,
		border: `1px solid ${theme.palette.gray4.main}`,
		backgroundColor: "white",
		borderRadius: 0,
		borderTopLeftRadius: 4,
		borderBottomLeftRadius: 4,
	},
	sbConfigMenuDateBox: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		border: `1px solid ${theme.palette.gray4.main}`,
		borderLeft: "none",
		backgroundColor: "white",
		width: "100%",
		height: 37,
		padding: "6px 10px",
	},
	sbLeftDateBox: {
		borderTopLeftRadius: 0,
		borderBottomLeftRadius: 0,
	},
	sbRightDateBox: {
		borderTopRightRadius: 4,
		borderBottomRightRadius: 4,
	},
	dateInput: {
		fontFamily: "inherit",
		fontSize: "inherit",
		outline: "none",
		"&:focus": {
			borderColor: theme.palette.primary.main,
			borderLeft: `1px solid ${theme.palette.primary.main}`,
		},
	},
}));
